// src/lib/lead/actions/deleteLead.ts
import type { Lead } from "@/types/lead";
import type { MergeSuggestion } from "./mergeLeadIntoCurrent";

export type DeleteLeadDeps = {
  setLeads: React.Dispatch<React.SetStateAction<Lead[]>>;
  setCurrentLead: (l: Lead | null) => void;
  setTranscript: (t: string) => void;
  setIsListening: (b: boolean) => void;
  setMergeSuggestion: React.Dispatch<React.SetStateAction<MergeSuggestion | null>>;

  // modal
  pendingSendLead: any;
  setPendingSendLead: (v: any) => void;
  setDuplicateMatches: React.Dispatch<React.SetStateAction<Lead[]>>;
  setDuplicateReason: (v: any) => void;

  // refs
  currentLeadRef: React.MutableRefObject<Lead | null>;
  listeningRef: React.MutableRefObject<boolean>;
};

export function deleteLeadAction(id: string, deps: DeleteLeadDeps) {
  deps.setLeads((prev) => prev.filter((l) => l.id !== id));

  deps.setDuplicateMatches((prev) => {
    const next = prev.filter((l) => l.id !== id);
    if (deps.pendingSendLead && next.length === 0) {
      deps.setPendingSendLead(null);
      deps.setDuplicateReason(null);
    }
    return next;
  });

  if (deps.currentLeadRef.current?.id === id) {
    deps.setCurrentLead(null);
    deps.currentLeadRef.current = null;

    deps.setTranscript("");
    deps.setIsListening(false);
    deps.listeningRef.current = false;

    deps.setMergeSuggestion((prev) => (prev?.sourceId === id ? null : prev));
  }
}